import { useContext } from "react"

import { Play } from 'lucide-react'
import { PrintButton } from "../Printer/checklist/PrintButton"
import { Action } from "../../../ui/Action"
import {useMerchant} from "../../../../store/global/useMerchant";

export function StartService({ onClick: callbackFn = () => { }, beforeClick = () => { }, token, ...rest }) {
  const merchant = useMerchant(st=>st.data.merchant)

  const browserPrinter = !!merchant?.activeModules?.['impressora-bandt']
  const printerAssistent = !!merchant?.activeModules?.['impressora-bandt-v2']

  const StartServiceButton = printerAssistent ? PrintButton : Action.Root;

  const printAction = () => {
    if (browserPrinter && !printerAssistent) {
      window.open(
        `https://printer.petlandbrasil.com.br/?token=${token}`,
        'popup',
        'width=350, height=255, top=100, left=110, scrollbars=no',
      );
    }
    callbackFn();
  }

  return (
    <StartServiceButton {...rest} beforeClick={beforeClick} onClick={printAction}>
      <Action.Icon icon={Play} />
      INICIAR ATENDIMENTO
    </StartServiceButton>
  )
}
